import { defineMessages } from 'react-intl-next';

export const messages: {
	positionExternalKey: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	positionTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	positionExternalKey: {
		id: 'search_talent_position.external_position_key',
		defaultMessage: 'External key {positionExternalKey}',
		description: 'External ID of the position',
	},
	positionTitle: {
		id: 'search_talent_position.position_title',
		defaultMessage:
			'{preferredName, select, undefined {{positionKey}} other {{positionKey}: {preferredName}}}',
		description: 'Position title with position key',
	},
});
